<script>
import { USER_CONSTS as UC } from '@/stores/consts'
import { mapGetters } from 'vuex'
import { hasResourcePermission as HRP } from '@/utilities/userResourcePermissions'

export default {
  computed: {
    ...mapGetters(UC.NAMESPACE, ['permissions']),
  },
  methods: {
    hasResourcePermission(resourcePermission) {
      return HRP(resourcePermission, this.permissions)
    },
  },
}
</script>
